// App-specific config shape. Safety doesn't add anything beyond the base today;
// it extends `BaseDynamicConfig` so app-specific fields can be added here later
// without touching the shared loader.
import {
  loadConfig as loadBaseConfig,
  getConfig as getBaseConfig,
  type BaseDynamicConfig,
} from '@my/platform/config';

export type DynamicConfig = BaseDynamicConfig;

/** Fetch and cache `/config.json`. Call once at boot before render. */
export const loadConfig = (): Promise<DynamicConfig> => loadBaseConfig<DynamicConfig>();

/** Synchronous accessor — throws if `loadConfig()` hasn't resolved yet. */
export const getConfig = (): DynamicConfig => getBaseConfig<DynamicConfig>();
